import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NGOrganizationsService } from '../../../../shared/API-Service/services/ngorganizations.service';
import { environment } from 'src/environments/environment.prod';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-ngorganizations-details',
  templateUrl: './ngorganizations-details.component.html',
  styleUrls: ['./ngorganizations-details.component.css']
})
export class NgorganizationsDetailsComponent implements OnInit {
  customerinfo:any;
  id: string;
  NGOrganizationsDetails: any;
  situationReconcileImage: any;
  situationReconcileImageEx:any
  systemRegulations: string;
  systemRegulationsEx: any;
  certifiedApplication: string;
  certifiedApplicationEx: any;
  publicationCertificate:any;
  publicationCertificateEx:any;
   trusteesBoardCertifiedStatement: string;
   trusteesBoardCertifiedStatementEx: any;
   otherImage: string;
   otherImageEx: any;
  constructor(private NGOrganizationsService:NGOrganizationsService,private route : ActivatedRoute) { }
  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get("id")) {
      console.log(this.route.snapshot.paramMap.get("id"))
      
       this.id =this.route.snapshot.paramMap.get("id");
       this.NGOrganizationsService.GetNGOrganizationsById(this.id).subscribe(async (res:any)=>{
         this.NGOrganizationsDetails=  await res.data;
    console.log(this.NGOrganizationsDetails)
    this.situationReconcileImage=environment.ServerImages_URL+'/'+this.NGOrganizationsDetails.situationReconcileImage
    this.situationReconcileImageEx=this.situationReconcileImage.split('.').pop();

    this.systemRegulations=environment.ServerImages_URL+'/'+this.NGOrganizationsDetails.systemRegulations
     this.systemRegulationsEx=this.systemRegulations.split('.').pop();
    
    this.certifiedApplication=environment.ServerImages_URL+'/'+this.NGOrganizationsDetails.certifiedApplication
     this.certifiedApplicationEx=this.certifiedApplication.split('.').pop();
    
     this.publicationCertificate=environment.ServerImages_URL+'/'+this.NGOrganizationsDetails.publicationCertificate
     this.publicationCertificateEx=this.publicationCertificate.split('.').pop();

    this.trusteesBoardCertifiedStatement=environment.ServerImages_URL+'/'+this.NGOrganizationsDetails.trusteesBoardCertifiedStatement
    this.trusteesBoardCertifiedStatementEx=this.trusteesBoardCertifiedStatement.split('.').pop();
    this.otherImage=environment.ServerImages_URL+'/'+this.NGOrganizationsDetails.otherImage
    this.otherImageEx=this.otherImage.split('.').pop();
         
       })
      // this.PartnersService.GetPartnersByid(this.id).subscribe(async (res:any)=>{
      //   console.log(res.data);
      // this.Partners=  await res.data;
      // this.imageLogo=environment.ServerImages_URL+'/'+this.Partners.image
      //   this.initForm(this.Partners);
        
      // })
     
    }
  }
OpenImage(imagesView){
    Swal.fire({
      imageUrl: imagesView,
      imageHeight: 400,
      imageAlt: 'A tall image',
      confirmButtonText:"الغاء"
    })
  }
  OpenPdf(imagesView){
    window.open(imagesView, "_blank");
 }
}
